import React, { useContext } from "react";
import { MaterialOrderSortTypes } from "../../../configs/sortTypes";
import { MaterialOrderFilterType } from "../../../configs/filterTypes";
import ListView from "../../../shared/components/ListView";
import { Search, TableColumns } from "../../../configs/materialOrder";
import { MaterialOrderRow } from "./MaterialOrderTable";
import { AuthenticationContext } from "../../../provider/AuthenticationProvider";
import { ROLE } from "../../../data/enums";

const MaterialOrderListTab = () => {
    const {
        user: { role },
    } = useContext(AuthenticationContext);

    const getTableColumns = () => {
        switch (role) {
            case ROLE.FIRST_STORAGE_KEEPER:
            case ROLE.SECOND_STORAGE_KEEPER:
                return TableColumns.filter((item) => item.text !== "Giá");
            case ROLE.LOGISTIC_STAFF:
            case ROLE.LOGISTIC_MANAGER:
            case ROLE.PURCHASING_STAFF:
            case ROLE.PRODUCTION_STAFF:
            case ROLE.SALE_MANAGER:
            case ROLE.SALE_STAFF:
            case ROLE.MANAGER:
            case ROLE.ACCOUNTANT_MANAGER:
                return TableColumns;
            default:
                return [];
        }
    };

    return (
        <ListView
            url="/materials/orders/"
            sortTypes={MaterialOrderSortTypes}
            filterTypes={MaterialOrderFilterType}
            rowElement={MaterialOrderRow}
            tableColumns={getTableColumns()}
            textString={Search.searchText}
        />
    );
};

export default MaterialOrderListTab;


